import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaClock,
  FaUser,
  FaHome,
} from "react-icons/fa";

const BlogBanner = ({ blog }) => {
  return (
    <section
      className="relative pt-32 md:pt-40 pb-16 md:pb-28"
      style={{
        backgroundImage: `linear-gradient(rgba(8,43,87,.92), rgba(8,43,87,.92)), url(${blog.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container-custom">

        {/* Breadcrumb */}

        <div className="flex flex-wrap justify-center items-center gap-3 text-white/80 mb-8">

          <Link
            to="/"
            className="flex items-center gap-2 hover:text-[#F59E0B]"
          >
            <FaHome />
            Home
          </Link>

          <span>/</span>

          <Link
            to="/blogs"
            className="hover:text-[#F59E0B]"
          >
            Blogs
          </Link>

          <span>/</span>

          <span className="text-[#F59E0B]">
            {blog.category}
          </span>

        </div>

        <div className="max-w-4xl mx-auto text-center">

          <span className="inline-block bg-[#F59E0B] text-white px-4 py-2 rounded-full text-sm">
            {blog.category}
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {blog.title}
          </h1>

          <div className="flex flex-wrap justify-center gap-8 mt-8 text-white/80">

            <div className="flex items-center gap-2">
              <FaUser />
              {blog.author}
            </div>

            <div className="flex items-center gap-2">
              <FaCalendarAlt />
              {blog.publishDate}
            </div>

            <div className="flex items-center gap-2">
              <FaClock />
              {blog.readTime}
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default BlogBanner;